import Container from "../../../../components/container";
import { ShoppingCategory } from "../../../../models";
import { DeleteShoppingCategory, UpdateShoppingCategory } from "./buttons";

export default function ShoppingCategoriesTable({
  shoppingCategories,
}: {
  shoppingCategories: ShoppingCategory[];
}) {
  return (
    <Container className=" max-w-xl">
      <div className="lg:hidden">
        {shoppingCategories?.map((shoppingCategory) => (
          <div
            key={shoppingCategory.id}
            className="mb-4 w-full rounded-md bg-white p-4"
          >
            <h2 className="text-lg font-semibold">{shoppingCategory.name}</h2>
            <div className="flex items-center justify-between pb-4 mt-2">
              {shoppingCategory.id ? (
                <div className="w-full flex items-center justify-center gap-2">
                  <UpdateShoppingCategory id={shoppingCategory.id.toString()} />
                  <DeleteShoppingCategory id={shoppingCategory.id.toString()} />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3 "></th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {shoppingCategories.map((shoppingCategory) => (
            <tr key={shoppingCategory.id} className="border-b">
              <td className="px-6 py-4 font-medium">{shoppingCategory.name}</td>
              <td className="px-6 py-4">
                {shoppingCategory.id ? (
                  <div className="flex items-center justify-end gap-2">
                    <UpdateShoppingCategory id={shoppingCategory.id.toString()} />
                    <DeleteShoppingCategory id={shoppingCategory.id.toString()} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
